import { Action } from 'redux';

export const CREATE_EMPRESA_REQUEST = 'CREATE_EMPRESA_REQUEST';
export const CREATE_EMPRESA_SUCCESS = 'CREATE_EMPRESA_SUCCESS';
export const CREATE_EMPRESA_FAILURE = 'CREATE_EMPRESA_FAILURE';

export const FETCH_EMPRESAS_REQUEST = 'FETCH_EMPRESAS_REQUEST';
export const FETCH_EMPRESAS_SUCCESS = 'FETCH_EMPRESAS_SUCCESS';
export const FETCH_EMPRESAS_FAILURE = 'FETCH_EMPRESAS_FAILURE';

export const FETCH_EMPRESA_REQUEST = 'FETCH_EMPRESA_REQUEST';
export const FETCH_EMPRESA_SUCCESS = 'FETCH_EMPRESA_SUCCESS';
export const FETCH_EMPRESA_FAILURE = 'FETCH_EMPRESA_FAILURE';

export const UPDATE_EMPRESA_REQUEST = 'UPDATE_EMPRESA_REQUEST';
export const UPDATE_EMPRESA_SUCCESS = 'UPDATE_EMPRESA_SUCCESS';
export const UPDATE_EMPRESA_FAILURE = 'UPDATE_EMPRESA_FAILURE';

export const DELETE_EMPRESA_REQUEST = 'DELETE_EMPRESA_REQUEST';
export const DELETE_EMPRESA_SUCCESS = 'DELETE_EMPRESA_SUCCESS';
export const DELETE_EMPRESA_FAILURE = 'DELETE_EMPRESA_FAILURE';

export const SET_EMPRESAS_PAGE = 'SET_EMPRESAS_PAGE';
export const SET_EMPRESAS_LIMIT = 'SET_EMPRESAS_LIMIT';

export interface CreateEmpresaRequestAction extends Action<typeof CREATE_EMPRESA_REQUEST> {
  type: typeof CREATE_EMPRESA_REQUEST;
}

export interface CreateEmpresaSuccessAction extends Action<typeof CREATE_EMPRESA_SUCCESS> {
  type: typeof CREATE_EMPRESA_SUCCESS;
  payload: any;
}

export interface CreateEmpresaFailureAction extends Action<typeof CREATE_EMPRESA_FAILURE> {
  type: typeof CREATE_EMPRESA_FAILURE;
  payload: string;
}

export interface FetchEmpresasRequestAction extends Action<typeof FETCH_EMPRESAS_REQUEST> {
  type: typeof FETCH_EMPRESAS_REQUEST;
}

export interface FetchEmpresasSuccessAction extends Action<typeof FETCH_EMPRESAS_SUCCESS> {
  type: typeof FETCH_EMPRESAS_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchEmpresasFailureAction extends Action<typeof FETCH_EMPRESAS_FAILURE> {
  type: typeof FETCH_EMPRESAS_FAILURE;
  payload: string;
}

export interface FetchEmpresaRequestAction extends Action<typeof FETCH_EMPRESA_REQUEST> {
  type: typeof FETCH_EMPRESA_REQUEST;
}

export interface FetchEmpresaSuccessAction extends Action<typeof FETCH_EMPRESA_SUCCESS> {
  type: typeof FETCH_EMPRESA_SUCCESS;
  payload: any;
}

export interface FetchEmpresaFailureAction extends Action<typeof FETCH_EMPRESA_FAILURE> {
  type: typeof FETCH_EMPRESA_FAILURE;
  payload: string;
}

export interface UpdateEmpresaRequestAction extends Action<typeof UPDATE_EMPRESA_REQUEST> {
  type: typeof UPDATE_EMPRESA_REQUEST;
}

export interface UpdateEmpresaSuccessAction extends Action<typeof UPDATE_EMPRESA_SUCCESS> {
  type: typeof UPDATE_EMPRESA_SUCCESS;
  payload: any;
}

export interface UpdateEmpresaFailureAction extends Action<typeof UPDATE_EMPRESA_FAILURE> {
  type: typeof UPDATE_EMPRESA_FAILURE;
  payload: string;
}

export interface DeleteEmpresaRequestAction extends Action<typeof DELETE_EMPRESA_REQUEST> {
  type: typeof DELETE_EMPRESA_REQUEST;
}

export interface DeleteEmpresaSuccessAction extends Action<typeof DELETE_EMPRESA_SUCCESS> {
  type: typeof DELETE_EMPRESA_SUCCESS;
  payload: string;
}

export interface DeleteEmpresaFailureAction extends Action<typeof DELETE_EMPRESA_FAILURE> {
  type: typeof DELETE_EMPRESA_FAILURE;
  payload: string;
}

export interface SetEmpresasPageAction extends Action<typeof SET_EMPRESAS_PAGE> {
  type: typeof SET_EMPRESAS_PAGE;
  payload: number;
}

export interface SetEmpresasLimitAction extends Action<typeof SET_EMPRESAS_LIMIT> {
  type: typeof SET_EMPRESAS_LIMIT;
  payload: number;
}

export type EmpresasActionTypes =
  | CreateEmpresaRequestAction
  | CreateEmpresaSuccessAction
  | CreateEmpresaFailureAction
  | FetchEmpresasRequestAction
  | FetchEmpresasSuccessAction
  | FetchEmpresasFailureAction
  | FetchEmpresaRequestAction
  | FetchEmpresaSuccessAction
  | FetchEmpresaFailureAction
  | UpdateEmpresaRequestAction
  | UpdateEmpresaSuccessAction
  | UpdateEmpresaFailureAction
  | DeleteEmpresaRequestAction
  | DeleteEmpresaSuccessAction
  | DeleteEmpresaFailureAction
  | SetEmpresasPageAction
  | SetEmpresasLimitAction;